import ClipLoader from "react-spinners/ClipLoader";

const Spinner = () => {
    return (
        <div style={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <ClipLoader color="#EB4260" />
        </div>
    )
}

export default Spinner